"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.PaymentMethod=void 0;var r;(function(e){e.Alternative="Alternative",e.BankTransfer="BankTransfer",e.CreditCard="CreditCard",e.DirectDebit="DirectDebit"})(r||(exports.PaymentMethod=r={}));
//# sourceMappingURL=PaymentMethod.js.map
